<template>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="600px" ref="dialog">
        <el-form :model="dataForm" ref="dataForm" label-width="155px" :inline="true" class="border-form"
            style="margin-right: 25px;margin-top: -15px;">
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="事由" class="fileItem">
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row class="set_border">
                <el-col :span="24">
                    <span class="set_data"> {{ fileTitle }}</span>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24" class="row-form-item">
                    <el-form-item label="处理及跟踪情况" class="fileItem">
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row style="margin-bottom: 10px;">
                <el-col :span="24">
                    <div>
                        <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="tracking">
                        </el-input>
                    </div>
                </el-col>
            </el-row>
            <el-row class="formBtnGroup">
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="dataFormSubmit()">确定</el-button>
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    @click="visible = false">取消</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { initDialogDrag } from '@/utils/dialogDrag.js'
export default {
    name: "tracking-dialog",
    data() {
        return {
            title: '处理及跟踪情况',
            fileId: '',
            visible: false,
            fileTitle: '',
            tracking: '',
            receiverOptions: '',
            dataForm: {}
        };
    },
    methods: {
        init(id) {
            this.fileId = id || '';
            this.getDetail();
            this.$nextTick(() => {
                this.visible = true;
                initDialogDrag(this.$refs.dialog.$el);
            });
        },

        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/noticeinfo/info/" + this.fileId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.tracking = data.body.tracking
                    this.receiverOptions = data.body.receiverOptions
                    this.fileTitle = data.body.fileTitle
                }
            });
        },

        dataFormSubmit() {
            let _url = "/business/noticeinfo/trackingNotice";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData({
                    fileId: this.fileId,
                    tracking: this.tracking,
                    receiverOptions: this.receiverOptions,
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            // 数据更新成功后，触发事件通知父组件刷新数据
                            this.$emit('refreshDataList');
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped="scoped">
::v-deep .el-dialog__header {
    height: 60px;
    line-height: 30px;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    flex: 1;
    font-size: 12px !important;
    padding: 2px 0 !important;
    /* 减少内边距 */
    line-height: 1.4;
    /* 设置统一的行高 */
}

.fileItem::v-deep .el-form-item__label {
    text-align: left;
    margin: 0px 0px !important;
    color: #00428e !important;
    font-weight: bold !important;
    width: 100% !important;
    max-height: 20px !important;
    background-color: #E1F1FF !important;
    display: flex;
    align-items: center;
}

.set_data {
    font-size: 14px;
    padding: 5px 10px !important;
    width: 100% !important;
}

.row-form-item {
    border: 0.5px solid #dadada;
}

.fileItem {
    padding-left: 10px !important;
}

.el-row.set_border {
    border-right: 0.5px solid #dadada;
    border-bottom: 0.5px solid #dadada;
    border-left: 0.5px solid #dadada;
}
</style>
